export const disabledDueToSharingPolicyText =
  "You are not permitted to update this link's settings. Contact your admin for assistance";
